<template>
  <v-card class="menu-button primary-shadow">
    <v-card-text>
      <v-container>
        <template v-if="personal">
          <v-row align="center" v-if="enrolamiento">
            <v-col cols="4" align="center" v-if="!enrolamiento.URL_Lateral1">
              <v-avatar color="primary" size="96" rounded readonly>
                <v-icon color="secondary" size="64">mdi-account</v-icon>
              </v-avatar>
            </v-col>
            <v-col cols="4" align="center" v-else>
              <v-img :src="enrolamiento.URL_Lateral1" max-width="96" aspect-ratio="1"></v-img>
            </v-col>
            <v-col cols="4" align="center" v-if="!personal.foto || personal.foto.length === 0">
              <v-avatar color="primary" size="96" rounded readonly>
                <v-icon color="secondary" size="64">mdi-account</v-icon>
              </v-avatar>
            </v-col>
            <v-col cols="4" align="center" v-else>
              <v-img :src="personal.foto" max-width="96" aspect-ratio="1"></v-img>
            </v-col>
            <v-col cols="4" align="center" v-if="!enrolamiento.URL_Lateral2">
              <v-avatar color="primary" size="96" rounded readonly>
                <v-icon color="secondary" size="64">mdi-account</v-icon>
              </v-avatar>
            </v-col>
            <v-col cols="4" align="center" v-else>
              <v-img :src="enrolamiento.URL_Lateral2" max-width="96" aspect-ratio="1"></v-img>
            </v-col>
          </v-row>
          <v-row align="center" v-else justify="center">
            <v-col cols="4" v-if="!personal.foto || personal.foto.length === 0">
              <v-avatar color="primary" size="96" rounded readonly>
                <v-icon color="secondary" size="64">mdi-account</v-icon>
              </v-avatar>
            </v-col>
            <v-col cols="4" align="center" v-else>
              <v-img :src="personal.foto" max-width="96" aspect-ratio="1"></v-img>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-col cols="12" align="center">
              <div class="text-subtitle-1 white--text font-weight-bold">{{ personal.apaterno }}</div>
              <div class="text-subtitle-2 white--text">
                {{ (personal.amaterno || '') + ' ' + (personal.nombre || '') + ' ' + (personal.segundoNombre || '') }}
              </div>
              <div v-if="personal.fechaNacimiento" class="text-subtitle-2 white--text">
                {{ getAge(personal.fechaNacimiento) }}
              </div>
              <div v-else class="text-subtitle-2 white--text">Fecha de nacimiento no registrada</div>
              <v-chip class="black--text my-2 font-weight-bold" color="primary" small>
                {{ personal.CatEstatus && personal.CatEstatus.title ? personal.CatEstatus.title : 'Sin estatus' }}
              </v-chip>
            </v-col>
            <v-col cols="2" align="center" v-for="(condecoracion, index) in condecoraciones" :key="index">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-img :src="condecoracion.CatCondecoracion.icono" width="48" v-on="on" v-bind="attrs"></v-img>
                </template>
                <span>{{ condecoracion.CatCondecoracion.condecoracion }}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="12">
              <v-divider class="primary darken-1"></v-divider>
            </v-col>
            <template v-if="personal.fk_idEstatus < 7">
              <v-col cols="4" class="py-0">
                <div class="text-subtitle-2 primary--text">CUIP:</div>
              </v-col>
              <v-col cols="8" align="right">
                <div class="text-subtitle-2 font-weight-bold primary--text">{{ personal.CUIP }}</div>
              </v-col>
              <v-col cols="7">
                <div class="text-subtitle-2 primary--text">Número de credencial:</div>
              </v-col>
              <v-col cols="5" align="right">
                <div class="text-subtitle-2 font-weight-bold primary--text">{{ personal.numeroCredencial }}</div>
              </v-col>
              <v-col cols="12">
                <v-divider class="primary darken-1"></v-divider>
              </v-col>
            </template>
            <template
              v-if="
                personal.fk_idEstatus < 7 &&
                (perfil === PERFILES['Administrador IPH+'] ||
                  perfil === PERFILES['Armeria'] ||
                  perfil === PERFILES['ARMERIA_LOC'] ||
                  perfil === PERFILES['ARMERIA_PERSONAL LOC'] ||
                  perfil === PERFILES['IFCSP_PROFESIONALIZACION'] ||
                  perfil === PERFILES['IFCSP_ADMINISTRADOR'])
              "
            >
              <v-col cols="8">
                <div class="text-subtitle-2 primary--text">Susceptible:</div>
              </v-col>
              <v-col cols="4" align="right">
                <v-icon :color="susceptibleC3 && susceptibleC3.susceptible ? 'green' : 'red'">
                  {{ susceptibleC3 && susceptibleC3.susceptible ? 'mdi-check-bold' : 'mdi-cancel' }}
                </v-icon>
              </v-col>
            </template>
            <template
              v-if="
                personal.fk_idEstatus < 7 &&
                (perfil === PERFILES['Administrador IPH+'] || perfil === PERFILES.DP_EVALUACIONES)
              "
            >
              <v-col cols="8">
                <div class="text-subtitle-2 primary--text">Fecha de evaluación de desempeño:</div>
              </v-col>
              <v-col cols="4" align="right">
                <div class="text-subtitle-2 font-weight-bold primary--text">
                  {{ latestEvaluacionDesempenioDate ? latestEvaluacionDesempenioDate : 'Sin registro' }}
                </div>
              </v-col>
            </template>
            <template
              v-if="
                personal.fk_idEstatus < 7 &&
                (perfil === PERFILES['Administrador IPH+'] ||
                  perfil === PERFILES['Armeria'] ||
                  perfil === PERFILES['ARMERIA_LOC'] ||
                  perfil === PERFILES['ARMERIA_PASE DE LISTA'])
              "
            >
              <v-col cols="9">
                <div class="text-subtitle-2 primary--text">Permitir tercer arma:</div>
              </v-col>
              <v-col class="py-0" cols="3" align="right">
                <v-switch
                  color="primary"
                  inset
                  :input-value="personal.portacionArma"
                  @change="openConfirmTercerArmaDialog"
                ></v-switch>
              </v-col>
            </template>
          </v-row>
        </template>
        <template v-else>
          <v-row justify="center">
            <v-col cols="12" align="center">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </v-col>
          </v-row>
        </template>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { DIALOG_TYPES } from '@src/plugins/dialog-types'
import { PERFILES } from '@/perfiles.js'

export default {
  data() {
    return {
      PERFILES,
      DIALOG_TYPES,
    }
  },
  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
    ...mapGetters({
      perfil: 'getPerfil',
    }),
    ...mapGetters('resultadosPersonalesC3', {
      susceptibleC3: 'getSusceptibleC3',
    }),
    idPersonal() {
      return this.personal?.idPersonal
    },
    ...mapGetters('enrolamiento', {
      enrolamientos: 'getEnrolamientos',
    }),
    ...mapGetters('condecoraciones', {
      allCondecoraciones: 'getCondecoraciones',
    }),
    ...mapGetters('respetoPrincipios', {
      latestEvaluacionDesempenioDate: 'getLatestEvaluacionDesempenioDate',
    }),
    enrolamiento() {
      return this.enrolamientos.find((e) => e.fk_idPersonal === this.idPersonal) || null
    },
    condecoraciones() {
      return this.allCondecoraciones.filter((c) => c.fk_idPersonal === this.idPersonal)
    },
  },

  async mounted() {
    if (this.idPersonal) {
      await this.fetchEnrolamientoByPersonal(this.idPersonal)
      await this.fetchCondecoraciones()
      await this.fetchRespetoPrincipios(this.idPersonal)
      await this.fetchResultados(this.idPersonal)
    }
  },
  methods: {
    ...mapActions('enrolamiento', ['fetchEnrolamientoByPersonal']),
    ...mapActions('resultadosPersonalesC3', ['fetchResultados']),
    ...mapActions('condecoraciones', ['fetchCondecoraciones']),
    ...mapActions('personal', ['updatePersonal', 'fetchPersonalByID']),
    ...mapActions('respetoPrincipios', ['fetchRespetoPrincipios']),
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapMutations('personal', ['SET_PERSONAL_SINGLE']),

    openConfirmTercerArmaDialog() {
      this.SET_DIALOG({
        ...DIALOG_TYPES.CONFIRMACION_TERCER_ARMA_PERSONAL,
        props: {
          item: this.personal,
          onConfirm: this.confirmTercerArma,
        },
      })
    },
    async confirmTercerArma() {
      try {
        const updatedPersonal = { ...this.personal, portacionArma: !this.personal.portacionArma }
        await this.updatePersonal(updatedPersonal)
        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Se permitió la portación de tercer arma correctamente.', {
          root: true,
        })
        this.SET_PERSONAL_SINGLE(updatedPersonal)
        this.$store.dispatch('dialog/closeDialog')
      } catch (error) {
        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Error al actualizar la portación de arma.', { root: true })
      }
    },
  },
}
</script>
